import React from 'react';

const ARROW = 'M3.82475e-07 5.625L7.625 5.625L4.125 9.125L5 10L10 5L5 -4.37114e-07L4.125 0.874999L7.625 4.375L4.91753e-07 4.375L3.82475e-07 5.625Z';

export default function FillButton({
  children,
  className = '',
  bgColor = '#0C1312',
  textColor = '#ffffff',
  fillBgColor = '#ffffff',
  fillTextColor = '#0C1312',
  hoverFillBgColor,
  hoverFillTextColor,
  as: Tag = 'a',
  style = {},
  ...props
}) {
  const vars = {
    '--btn-bg': bgColor,
    '--btn-text': textColor,
    '--btn-fill-bg': fillBgColor,
    '--btn-fill-text': fillTextColor,
    '--btn-fill-bg-hover': hoverFillBgColor || fillBgColor,
    '--btn-fill-text-hover': hoverFillTextColor || fillTextColor,
    '--btn-arrow': fillTextColor,
    '--btn-arrow-hover': hoverFillTextColor || fillTextColor,
    ...style,
  };

  return (
    <Tag type={Tag === 'button' ? 'button' : undefined} className={`ob-fill-btn ${className}`} style={vars} {...props}>
      <span className="ob-fill-btn__text">{children}</span>
      <span aria-hidden="true" className="ob-fill-btn__circle">
        <span>{children}</span>
        <span className="ob-fill-btn__circle-text">
          <svg viewBox="0 0 10 10" fill="none" className="ob-fill-btn__icon">
            <path fillRule="evenodd" clipRule="evenodd" d={ARROW} className="ob-fill-btn__path" />
            <path fillRule="evenodd" clipRule="evenodd" d={ARROW} className="ob-fill-btn__path" />
          </svg>
        </span>
      </span>
    </Tag>
  );
}
